import React from 'react';
import propTypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { useStore } from '@thd-nucleus/experience-context';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { GuestHomepage } from './GuestHomepage';

// https://assets.thdstatic.com/experiences/my-homepage/vendor.1ad5d7a953b69cf8746d.css?v=1
// https://assets.thdstatic.com/experiences/my-homepage/vendor.1ad5d7a953b69cf8746d.css
const { string, bool } = propTypes;

export const GuestHomepageContainer = ({ slug, thdSEOBotDetection }) => {

  const { isCustomerIdentified = false } = useThdCustomer();
  const store = useStore();
  const { isLocalized } = store;

  const hpDefaultVariables = {
    isBrandPricingPolicyCompliant: isLocalized ? isCustomerIdentified : false
  };

  return (
    <ErrorBoundary name="my-homepage-content">
      <QueryProvider
        cacheKey="consumer-homepage"
        defaultVariables={hpDefaultVariables}
      >
        <GuestHomepage slug={slug} thdSEOBotDetection={thdSEOBotDetection} />
      </QueryProvider>
    </ErrorBoundary>
  );
};

GuestHomepageContainer.propTypes = {
  slug: string,
  thdSEOBotDetection: bool
};

GuestHomepageContainer.defaultProps = {
  slug: undefined,
  thdSEOBotDetection: false
};
